import addToCart from './add_to_cart';

'use strict'

function initializeCart() {
  addToCart();

  $('.cart__item-actions .button').on('click', function () {
    $.ajax({
      type: "POST",
      url: $(this).parents('div[data-url]').data('url'),
      // The key needs to match your method's input parameter (case-sensitive).
      data: JSON.stringify(
        {
          id: $(this).data('uid'),
          isProduct: $(this).data('product'),
          quantity: parseInt($(this).parent('.cart__item-actions').find('.cart__quantity').val()),
          modification: 0
        }),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
    }).done((data) => {
      if (data.status == 200) {
        $('.header-vts__cart-dot').text(data.count);
        if (data.count == 0) {
          $('.header-vts__cart-dot').addClass("hidden");
        } else {
          $('.header-vts__cart-dot').removeClass("hidden");
          document.querySelector('.mdc-snackbar span').textContent = "Cart has been updated";
          snackbar.open();
        }
      } else {
        console.log("We couldn't add the product to the cart")
      };
    }).fail(function () {
      alert("An error occurred while processing your request. Please try again.");
    });
  });


  let moved = false;
  if (document.querySelector(".header-vts__search-input")) {
    document
      .querySelector(".header-vts__search-input")
      .addEventListener("input", function () {
        if (
          !moved &&
          document.querySelector(".header-vts__suggestions") &&
          document.querySelector(".autocomplete-suggestions")
        ) {
          document
            .querySelector(".header-vts__suggestions")
            .appendChild(document.querySelector(".autocomplete-suggestions"));
          addObserver();
          moved = true;
        }
      });
  }

  function addObserver() {
    if (document.querySelector('.header-vts__suggestions') && document.querySelector('.autocomplete-suggestions')) {
      document.querySelector('.header-vts__suggestions').appendChild(document.querySelector('.autocomplete-suggestions'));
      var blocker = document.querySelector('.autocomplete-suggestions');
      var previousValue = blocker.style.display;

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName !== 'style') return;
          var currentValue = mutation.target.style.display;
          if (currentValue !== previousValue) {
            if (previousValue === "none" && currentValue !== "none") {
              document.querySelector('.header-vts__suggestions--empty').style.display = "none";
            } else {
              document.querySelector('.header-vts__suggestions--empty').style.display = "block";
            }

            previousValue = mutation.target.style.display;
          }
        });
      });

      observer.observe(blocker, { attributes: true });
    }
  }
}

export default initializeCart;
